module.exports = __webpack_public_path__ + "img/phone-icon.b02c9032.svg";